/* eslint-disable @typescript-eslint/no-unused-vars */

xplenty.directive('workflowOperatorEditor', [
  function () {
    return {
      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('./workflow-operator-editor.html'),

      replace: true,

      scope: false,

      link(scope, element, attrs) {},

      controller: ['$scope', '$stateParams', function ($scope, $stateParams) {}],
    };
  },
]);
